import _sfc_main from "./DatePicker.vue2.js";
/* empty css                */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const DatePicker = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-48930d7d"]]);
export {
  DatePicker as default
};
//# sourceMappingURL=DatePicker.vue.js.map
